export default __webpack_public_path__ + "static/media/a12.5e54793e.webp";